import api from './index'
import { axios } from '@/utils/request'

export function getCustomerList (parameter = {}) {
  return axios({
    url: '/customer/list',
    method: 'post',
    data: parameter
  })
}

export function getCustomerQryList (parameter = {}) {
  return axios({
    url: '/customer/infoQryList',
    method: 'post',
    data: parameter
  })
}

export function editCustomer (parameter = {}) {
  return axios({
    url: '/customer/edit',
    method: 'post',
    data: parameter
  })
}

export function editFacebook (parameter = {}) {
  return axios({
    url: '/customer/editFb',
    method: 'post',
    data: parameter
  })
}

export function getCustomerDetail (parameter = {}) {
  return axios({
    url: '/customer/detail',
    method: 'post',
    data: parameter
  })
}



export function getCreditApp (parameter = {}) {
  return axios({
    url: '/inxpfm/custContact/selectContact',
    method: 'post',
    data: parameter
  })
}


export function checkBankCard (parameter = {}) {
  return axios({
    url: '/risk/bankCheck',
    method: 'post',
    data: parameter
  })
}

export function operationInfoForCust (parameter = {}) {
  return axios({
    url: '/statistics/operationInfoForCust',
    method: 'post',
    data: parameter
  })
}

export function addWritelist(parameter = {}) {
  return axios({
    url: '/customer/addWritelist',
    method: 'post',
    data: parameter
  })
}

export function removeSmsCount(parameter = {}) {
  return axios({
    url: '/customer/removeSmsCount',
    method: 'post',
    data: parameter
  })
}


export function getCustLeavingMessage (parameter = {}) {
  return axios({
    url: '/customer/listCustComplain',
    method: 'post',
    data: parameter
  })
}


export function getCustLeavingMessageDetail (parameter = {}) {
  return axios({
    url: '/customer/viewCustComplain',
    method: 'post',
    data: parameter
  })


}

export function updateCustLeavingMessage (parameter = {}) {
  return axios({
    url: '/customer/replyCustComplain',
    method: 'post',
    data: parameter
  })
}

export function getCustById (custInfoId) {
  return axios({
    url: '/customer/selectById?custInfoId=' + custInfoId,
    method: 'get'
  })
}

export function getCustOrderDetail (appSsid, mobileNo) {
  return axios({
    url: '/customer/custOrderDetail?appSsid=' + appSsid + '&mobileNo=' + mobileNo,
    method: 'post',
  })
}

export function getRiskOperationInfo(mobileNo, appSsid) {
  return axios({
    url: '/trans/getRiskPointByParams?mobileNo=' + mobileNo + '&appSsid=' + appSsid,
    method: 'post'
  })
}

export function queryCustMessageBorad (parameter = {}) {
  return axios({
    url: '/customer/queryCustMessageBorad',
    method: 'post',
    data: parameter
  })
}

//添加联系人
export function addAlternateContact (parameter = {}) {
  return axios({
    url: '/customer/addAlternateContact',
    method: 'post',
    data: parameter
  })
}

export function getUserOperationFlowInfo (parameter = {}) {
  return axios({
    url: '/getUserOperationFlowInfo',
    method: 'post',
    data: parameter
  })
}

export function findAllUserInfo (parameter = {}) {
  return axios({
    url: '/user/findAllUserInfo',
    method: 'get',
    data: parameter
  })
}

export function queryNotRegisteredCustInfo(parameter = {}) {
  return axios({
    url: '/customer/getNotRegisteredCustInfo',
    method: 'post',
    data: parameter
  })
}



